import useSWR from 'swr';

export async function fetcher(url) {
	const res = await fetch(url);
	const body = await res.json().catch(() => null);

	if (!res.ok) {
		throw new Error(
			body?.error || `Request failed with status ${res.status}`
		);
	}

	return body;
}

export const swrConfig = { fetcher, revalidateOnFocus: false };

export function useData(type) {
	const { data, error, isLoading } = useSWR(`/api/dashboard/${type}`);

	return { data, isLoading, isError: error };
}

export function useTagsData(type) {
	const { data, error, isLoading } = useSWR(`/api/dashboard/${type}/tags`);

	return { data, isLoading, isError: error };
}
